/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { map, filter, find } from "lodash";
import { useSelector } from "react-redux";
import { useState, state, forwardRef, useImperativeHandle } from "react";
import toast from "react-hot-toast";
import validator from "validator";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import moment from "moment";

const InformacionGeneralMenor = forwardRef(
  ({ Back, Next, IntentoSolicitud, props, vista = "registrar", desactivar }, ref) => {
    const { catalogos } = useSelector((state) => state.solicitud);
    //habilitr campos
    const [disabled_txt, setdisabled_txt] = useState(false);
    //fecha de nacimiento
    let fechaNac = "";
    if (typeof props?.fechaNacimiento === "string" && props?.fechaNacimiento.includes("T")) {
      fechaNac = moment(props.fechaNacimiento).format("YYYY-MM-DD");
    } else {
      fechaNac = props?.fechaNacimiento ? props.fechaNacimiento : "";
    }
    const [txtfechaNacimiento, settxtfechaNacimiento] = useState(fechaNac);

    const [isvalid_txtfechaNacimiento, isvalid_settxtfechaNacimiento] = useState(false);
    //nacionalidad
    const [textnacionalidad, settextnacionalidad] = useState(
      props?.nacionalidad ? props.nacionalidad : ""
    );
    const [isvalid_textnacionalidad, isvalid_settextnacionalidad] = useState(false);
    //Nombre del niño
    const [textapellidoP, settextapellidoP] = useState(
      props?.aPaternoCandidato ? props.aPaternoCandidato : ""
    );
    const [isvalid_textapellidoP, isvalid_settextapellidoP] = useState(false);
    const [textapellidoM, settextapellidoM] = useState(
      props?.aMaternoCandidato ? props.aMaternoCandidato : ""
    );
    const [isvalid_textapellidoM, isvalid_settextapellidoM] = useState(false);
    const [textnombre, settextnombre] = useState(
      props?.nombreCandidato ? props.nombreCandidato : ""
    );
    const [isvalid_textnombre, isvalid_settextnombre] = useState(false);

    //Lugar de nacimiento
    const [txtlugarnacimiento, settxtlugarnacimiento] = useState(
      props?.lugarNacimiento ? props.lugarNacimiento : ""
    );
    const [isvalid_txtlugarnacimiento, isvalid_settxtlugarnacimiento] = useState(false);
    //sexo
    const [cmbsexo, setcmbsexo] = useState(props?.idSexo ?? null);
    const [isvalid_cmbsexo, isvalid_setcmbsexo] = useState(false);
    //datos del padre
    const [txtnombrepadre, settxtnombrepadre] = useState(
      props?.nombrePadre ? props.nombrePadre : ""
    );
    const [isvalid_txtnombrepadre, isvalid_settxtnombrepadre] = useState(false);

    const [textapaternopadre, settextapaternopadre] = useState(
      props?.aPaternoPadre ? props.aPaternoPadre : ""
    );
    const [isvalid_textapaternopadre, isvalid_settextapaternopadre] = useState(false);

    const [textamaternopadre, settextamaternopadre] = useState(
      props?.aMaternoPadre ? props.aMaternoPadre : ""
    );
    const [isvalid_textamaternopadre, isvalid_settextamaternopadre] = useState(false);
    //ocupacion padre
    const [textocupacionpadre, settextocupacionpadre] = useState(
      props?.ocupacionPadre ? props.ocupacionPadre : ""
    );
    const [isvalid_textocupacionpadre, isvalid_settextocupacionpadre] = useState(false);
    //datos de la madre
    const [textnombremadre, settextnombremadre] = useState(
      props?.nombreMadre ? props.nombreMadre : ""
    );
    const [isvalid_textnombremadre, isvalid_settextnombremadre] = useState(false);

    const [textapaternomadre, settextapaternomadre] = useState(
      props?.aPaternoMadre ? props.aPaternoMadre : ""
    );
    const [isvalid_textapaternomadre, isvalid_settextapaternomadre] = useState(false);

    const [textamaternomadre, settextamaternomadre] = useState(
      props?.aMaternoMadre ? props.aMaternoMadre : ""
    );
    const [isvalid_textamaternomadre, isvalid_settextamaternomadre] = useState(false);
    //ocupacion madre
    const [textocupacionmadre, settextocupacionmadre] = useState(
      props?.ocupacionMadre ? props.ocupacionMadre : ""
    );
    const [isvalid_textocupacionmadre, isvalid_settextocupacionmadre] = useState(false);
    //direccion niño
    const [textdireccionnino, settextdireccionnino] = useState(
      props?.direccionCandidato ? props.direccionCandidato : ""
    );
    const [isvalid_textdireccionnino, isvalid_settextdireccionnino] = useState(false);

    const [textcuidadorninioP, settextcuidadorninioP] = useState(
      props?.aPaternoCuidador ? props.aPaternoCuidador : ""
    );
    const [isvalid_textcuidadorninioP, isvalid_settextcuidadorninioP] = useState(false);

    const [textcuidadorninioM, settextcuidadorninioM] = useState(
      props?.aMaternoCuidador ? props.aMaternoCuidador : ""
    );
    const [isvalid_textcuidadorninioM, isvalid_settextcuidadorninioM] = useState(false);

    const [textcuidadorninioN, settextcuidadorninioN] = useState(
      props?.nombreCuidador ? props.nombreCuidador : ""
    );
    const [isvalid_textcuidadorninioN, isvalid_settextcuidadorninioN] = useState(false);
    //entidad
    const [cmbentidad, setcmbentidad] = useState(props?.idEntidad ?? null);
    const [isvalid_cmbentidad, isvalid_setcmbentidad] = useState(false);
    //municipio
    var municipios = filter(catalogos.municipios, (item) => {
      return item.idEntidad == props?.idEntidad;
    });

    const [cmbmuicipios, setcmbmuicipios] = useState(municipios ?? []);
    const [isvalid_cmbmunicipioselect, isvalid_setcmbmunicipioselect] = useState(false);
    const [cmbmunicipioselect, setcmbmunicipioselect] = useState(props?.idMunicipio ?? null);

    const [cmbparentesco, setcmbparentesco] = useState(
      props?.idParentescoCuidador ? props.idParentescoCuidador : null
    );
    const [isvalid_cmbparentesco, isvalid_setcmbparentesco] = useState(false);
    const [textParentescoespec, settextParentescoespec] = useState(
      props?.especifiqueParentescoCuidador ? props.especifiqueParentescoCuidador : ""
    );
    const [isValid_textParentescoespec, setisValid_settextParentescoespec] = useState(false);
    const [disabled_textParentescoespec, setidisabled_settextParentescoespec] = useState(true);

    const [cmbsermedico, setcmbsermedico] = useState(
      props?.idServicioMedico ? props.idServicioMedico : null
    );
    const [isvalid_cmbsermedico, isvalid_setcmbsermedico] = useState(false);

    const [textsermedicoOtro, settextsermedicoOtro] = useState(
      props?.otroServicioMedico ? props.otroServicioMedico : ""
    );
    const [isvalid_textsermedicoOtro, isvalid_settextsermedicoOtro] = useState(false);
    const [disabled_textsermedicoOtro, setidisabled_settextsermedicoOtro] = useState(true);

    const [textcalculomesesanio, settextcalculomesesanio] = useState(
      props?.textcalculomesesanio ? props.textcalculomesesanio : ""
    );
    //const [isvalid_, isvalid_set] = useState(false);
    const [textdirpediatra, settextdirpediatra] = useState(
      props?.direccionPediatra ? props.direccionPediatra : ""
    );
    const [isvalid_textdirpediatra, isvalid_settextdirpediatra] = useState(false);

    const [textmedicopediatra1ercontacto, settextmedicopediatra1ercontacto] = useState(
      props?.nombrePediatra ? props.nombrePediatra : ""
    );
    const [isvalid_textmedicopediatra1ercontacto, isvalid_settextmedicopediatra1ercontacto] =
      useState(false);
    const [textcelularmedico1ercontacto, settextcelularmedico1ercontacto] = useState(
      props?.celularPediatra ? props.celularPediatra : ""
    );
    const [isvalid_textcelularmedico1ercontacto, isvalid_settextcelularmedico1ercontacto] =
      useState(false);

    const [isEnvioIntentoSolicitud, setisEnvioIntentoSolicitud] = useState(false);

    const ValidaEdadCandidato = (value) => {
      if (value) {
        var dt1 = new Date(value);
        var dt2 = new Date();
        var meses = monthDiff(dt1, dt2);
        settextcalculomesesanio(meses + " MESES");
        if (meses <= 24) {
          isvalid_settxtfechaNacimiento(false);
          setdisabled_txt(false);
        } else {
          isvalid_settxtfechaNacimiento(true);
          setdisabled_txt(true);
          //insertar intento de solicitud
          if (!isEnvioIntentoSolicitud) {
            IntentoSolicitud({
              aPaternoCandidato: textapellidoP,
              aMaternoCandidato: textapellidoM,
              nombreCandidato: textnombre,
              fechaNacimiento: value,
              motivo: meses + " MESES",
            });
            setisEnvioIntentoSolicitud(true);
          }
        }
      } else {
        settextcalculomesesanio("");
        isvalid_settxtfechaNacimiento(false);
        setdisabled_txt(false);
      }
    };
    function monthDiff(dateFrom, dateTo) {
      return (
        dateTo.getMonth() -
        dateFrom.getMonth() +
        12 * (dateTo.getFullYear() - dateFrom.getFullYear())
      );
    }

    const ValidaForm = () => {
      if (!textapellidoP) {
        toast.error("Campo Obligatorio *");
        isvalid_settextapellidoP(true);
        return null;
      }
      if (!textapellidoM) {
        toast.error("Campo Obligatorio *");
        isvalid_settextapellidoM(true);
        return null;
      }

      if (!textnombre) {
        toast.error("Campo Obligatorio *");
        isvalid_settextnombre(true);
        return null;
      }

      if (!txtfechaNacimiento) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtfechaNacimiento(true);
        return null;
      }

      if (!textnacionalidad) {
        toast.error("Campo Obligatorio *");
        isvalid_settextnacionalidad(true);
        return null;
      }
      if (!txtlugarnacimiento) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtlugarnacimiento(true);
        return null;
      }
      if (!cmbsexo) {
        toast.error("Campo Obligatorio *");
        isvalid_setcmbsexo(true);
        return null;
      }
      if (
        !textapaternomadre &&
        !textamaternomadre &&
        !textnombremadre &&
        !textocupacionmadre &&
        !textapaternopadre &&
        !textamaternopadre &&
        !txtnombrepadre &&
        !textocupacionpadre
      ) {
        toast.error("Debe ingresar la información de al menos el padre o la madre *");
        isvalid_settextapaternomadre(true);
        isvalid_settextamaternomadre(true);
        isvalid_settextnombremadre(true);
        isvalid_settextocupacionmadre(true);
        isvalid_settextapaternopadre(true);
        isvalid_settextamaternopadre(true);
        isvalid_settxtnombrepadre(true);
        isvalid_settextocupacionpadre(true);
        return null;
      }

      if (
        !textapaternomadre &&
        !textapaternopadre &&
        !textamaternopadre &&
        !txtnombrepadre &&
        !textocupacionpadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settextapaternomadre(true);
        return null;
      }

      if (
        !textamaternomadre &&
        !textapaternopadre &&
        !textamaternopadre &&
        !txtnombrepadre &&
        !textocupacionpadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settextamaternomadre(true);
        return null;
      }
      if (
        !textnombremadre &&
        !textapaternopadre &&
        !textamaternopadre &&
        !txtnombrepadre &&
        !textocupacionpadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settextnombremadre(true);
        return null;
      }
      if (
        !textocupacionmadre &&
        !textapaternopadre &&
        !textamaternopadre &&
        !txtnombrepadre &&
        !textocupacionpadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settextocupacionmadre(true);
        return null;
      }
      if (
        !textapaternopadre &&
        !textapaternomadre &&
        !textamaternomadre &&
        !textnombremadre &&
        !textocupacionmadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settextapaternopadre(true);
        return null;
      }
      if (
        !textamaternopadre &&
        !textapaternomadre &&
        !textamaternomadre &&
        !textnombremadre &&
        !textocupacionmadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settextamaternopadre(true);
        return null;
      }

      if (
        !txtnombrepadre &&
        !textapaternomadre &&
        !textamaternomadre &&
        !textnombremadre &&
        !textocupacionmadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtnombrepadre(true);
        return null;
      }

      if (
        !textocupacionpadre &&
        !textapaternomadre &&
        !textamaternomadre &&
        !textnombremadre &&
        !textocupacionmadre
      ) {
        toast.error("Campo Obligatorio *");
        isvalid_settextocupacionpadre(true);
        return null;
      }
      if (!textdireccionnino) {
        toast.error("Campo Obligatorio *");
        isvalid_settextdireccionnino(true);
        return null;
      }

      if (!cmbentidad) {
        toast.error("Campo Obligatorio *");
        isvalid_setcmbentidad(true);
        return null;
      }
      if (!cmbmunicipioselect) {
        toast.error("Campo Obligatorio *");
        isvalid_setcmbmunicipioselect(true);
        return null;
      }

      if (!textmedicopediatra1ercontacto) {
        toast.error("Campo Obligatorio *");
        isvalid_settextmedicopediatra1ercontacto(true);
        return null;
      }
      if (!textcelularmedico1ercontacto) {
        toast.error("Campo Obligatorio *");
        isvalid_settextcelularmedico1ercontacto(true);
        return null;
      }
      if (!textdirpediatra) {
        toast.error("Campo Obligatorio *");
        isvalid_settextdirpediatra(true);
        return null;
      }

      if (!textcuidadorninioP) {
        toast.error("Campo Obligatorio *");
        isvalid_settextcuidadorninioP(true);
        return null;
      }
      if (!textcuidadorninioM) {
        toast.error("Campo Obligatorio *");
        isvalid_settextcuidadorninioM(true);
        return null;
      }
      if (!textcuidadorninioN) {
        toast.error("Campo Obligatorio *");
        isvalid_settextcuidadorninioN(true);
        return null;
      }
      if (!cmbparentesco) {
        toast.error("Campo Obligatorio *");
        isvalid_setcmbparentesco(true);
        return null;
      }
      if (cmbparentesco == "5" && !textParentescoespec) {
        toast.error("Campo Obligatorio *");
        setisValid_settextParentescoespec(true);
        return null;
      }
      if (!cmbsermedico) {
        toast.error("Campo Obligatorio *");
        isvalid_setcmbsermedico(true);
        return null;
      }
      if (cmbsermedico == "8" && !textsermedicoOtro) {
        toast.error("Campo Obligatorio *");
        isvalid_settextsermedicoOtro(true);
        return null;
      }

      var data = {
        aPaternoCandidato: textapellidoP,
        aMaternoCandidato: textapellidoM,
        nombreCandidato: textnombre,
        fechaNacimiento: txtfechaNacimiento,
        textcalculomesesanio,
        nacionalidad: textnacionalidad,
        lugarNacimiento: txtlugarnacimiento,
        idSexo: cmbsexo,
        aPaternoMadre: textapaternomadre,
        aMaternoMadre: textamaternomadre,
        nombreMadre: textnombremadre,
        ocupacionMadre: textocupacionmadre,
        aPaternoPadre: textapaternopadre,
        aMaternoPadre: textamaternopadre,
        nombrePadre: txtnombrepadre,
        ocupacionPadre: textocupacionpadre,
        direccionCandidato: textdireccionnino,
        idEntidad: cmbentidad,
        idMunicipio: cmbmunicipioselect,
        celularPediatra: textcelularmedico1ercontacto,
        nombrePediatra: textmedicopediatra1ercontacto,
        direccionPediatra: textdirpediatra,
        aPaternoCuidador: textcuidadorninioP,
        aMaternoCuidador: textcuidadorninioM,
        nombreCuidador: textcuidadorninioN,
        idParentescoCuidador: cmbparentesco,
        especifiqueParentescoCuidador: textParentescoespec,
        idServicioMedico: cmbsermedico,
        otroServicioMedico: textsermedicoOtro,
      };

      Next(data);
      return data;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      var data = {
        aPaternoCandidato: textapellidoP,
        aMaternoCandidato: textapellidoM,
        nombreCandidato: textnombre,
        fechaNacimiento: txtfechaNacimiento,
        textcalculomesesanio,
        nacionalidad: textnacionalidad,
        lugarNacimiento: txtlugarnacimiento,
        idSexo: cmbsexo,
        aPaternoMadre: textapaternomadre,
        aMaternoMadre: textamaternomadre,
        nombreMadre: textnombremadre,
        ocupacionMadre: textocupacionmadre,
        aPaternoPadre: textapaternopadre,
        aMaternoPadre: textamaternopadre,
        nombrePadre: txtnombrepadre,
        ocupacionPadre: textocupacionpadre,
        direccionCandidato: textdireccionnino,
        idEntidad: cmbentidad,
        idMunicipio: cmbmunicipioselect,
        celularPediatra: textcelularmedico1ercontacto,
        nombrePediatra: textmedicopediatra1ercontacto,
        direccionPediatra: textdirpediatra,
        aPaternoCuidador: textcuidadorninioP,
        aMaternoCuidador: textcuidadorninioM,
        nombreCuidador: textcuidadorninioN,
        idParentescoCuidador: cmbparentesco,
        especifiqueParentescoCuidador: textParentescoespec,
        idServicioMedico: cmbsermedico,
        otroServicioMedico: textsermedicoOtro,
      };

      Back(data);
    };

    return (
      <>
        {textcalculomesesanio ? (
          isvalid_txtfechaNacimiento ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}></Grid>
              <Grid item xs={12} md={9} lg={9}>
                <MDBox textAlign="center">
                  <Alert variant="filled" severity="warning">
                    Edad fuera de criterio: Al no cumplir con el criterio de edad del programa no es
                    posible seguir llenando la solicitud para aplicar
                  </Alert>
                </MDBox>
                <Divider />
              </Grid>
            </Grid>
          ) : null
        ) : null}

        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Nombre del niño(a)
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textapellidoP}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }
                    settextapellidoP(valor);
                  }}
                  error={isvalid_textapellidoP}
                  helperText={isvalid_textapellidoP ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextapellidoP(false);
                  }}
                  onBlur={() => {
                    if (!textapellidoP) isvalid_settextapellidoP(true);
                  }}
                  label={"A. Paterno"}
                  disabled={desactivar}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textapellidoM}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }
                    settextapellidoM(valor);
                  }}
                  error={isvalid_textapellidoM}
                  helperText={isvalid_textapellidoM ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextapellidoM(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textapellidoM) isvalid_settextapellidoM(true);
                  }}
                  label={"A. Materno"}
                  disabled={desactivar}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textnombre}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convierte la primera letra de CADA palabra a mayúscula
                    valor = valor.toLowerCase().replace(/(^\w|\s\w)/g, (letra) => {
                      return letra.toUpperCase();
                    });
                    settextnombre(valor);
                  }}
                  error={isvalid_textnombre}
                  helperText={isvalid_textnombre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextnombre(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textnombre) isvalid_settextnombre(true);
                  }}
                  label={"Nombre"}
                  disabled={desactivar}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Fecha de Nacimiento
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  value={txtfechaNacimiento}
                  onChange={(event) => {
                    settxtfechaNacimiento(event.target.value);
                    ValidaEdadCandidato(event.target.value);
                  }}
                  error={isvalid_txtfechaNacimiento}
                  helperText={isvalid_txtfechaNacimiento ? "Edad fuera de criterio" : ""}
                  //onFocus={()=>{isvalid_settxtfechaNacimiento(false)}}
                  onBlur={() => {
                    if (!txtfechaNacimiento) isvalid_settxtfechaNacimiento(true);
                  }}
                  onFocus={() => {
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                  }}
                  variant="outlined"
                  disabled={desactivar}
                  onKeyDown={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  style={{ width: "100%", marginBottom: "1.5rem", cursor: "pointer" }}
                  size="small"
                  type="date"
                  autoComplete="off"
                  inputProps={{
                    max: moment().format("YYYY-MM-DD"),
                  }}
                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  value={textcalculomesesanio}
                  label={""}
                  variant="outlined"
                  sx={{
                    width: "100%",
                    marginBottom: "1.5rem",
                    border: "none",
                    borderRadius: 5,
                    "& .Mui-disabled": {
                      color: "white",
                    },
                    backgroundColor: textcalculomesesanio
                      ? isvalid_txtfechaNacimiento
                        ? "red"
                        : "green"
                      : "transparent",
                  }}
                  size="small"
                  disabled={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Nacionalidad
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              value={textnacionalidad}
              onChange={(event) => {
                settextnacionalidad(event.target.value);
              }}
              error={isvalid_textnacionalidad}
              helperText={isvalid_textnacionalidad ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settextnacionalidad(false);
                if (!textapellidoP) {
                  isvalid_settextapellidoP(true);
                }
                if (!textapellidoM) {
                  isvalid_settextapellidoM(true);
                }
                if (!textnombre) {
                  isvalid_settextnombre(true);
                }
                if (!txtfechaNacimiento) {
                  isvalid_settxtfechaNacimiento(true);
                }
              }}
              onBlur={() => {
                if (!textnacionalidad) isvalid_settextnacionalidad(true);
              }}
              label={""}
              variant="outlined"
              style={{ width: "100%", marginBottom: "1.5rem" }}
              size="small"
              disabled={disabled_txt || desactivar}
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Lugar de Nacimiento
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              value={txtlugarnacimiento}
              onChange={(event) => {
                settxtlugarnacimiento(event.target.value);
              }}
              error={isvalid_txtlugarnacimiento}
              helperText={isvalid_txtlugarnacimiento ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settxtlugarnacimiento(false);
                if (!textapellidoP) {
                  isvalid_settextapellidoP(true);
                }
                if (!textapellidoM) {
                  isvalid_settextapellidoM(true);
                }
                if (!textnombre) {
                  isvalid_settextnombre(true);
                }
                if (!txtfechaNacimiento) {
                  isvalid_settxtfechaNacimiento(true);
                }
                if (!textnacionalidad) {
                  isvalid_settextnacionalidad(true);
                }
              }}
              onBlur={() => {
                if (!txtlugarnacimiento) isvalid_settxtlugarnacimiento(true);
              }}
              label={""}
              variant="outlined"
              style={{ width: "100%", marginBottom: "1.5rem" }}
              size="small"
              disabled={disabled_txt || desactivar}
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Sexo
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Autocomplete
              options={[
                {
                  id: "1",
                  descripcion: "Masculino",
                },
                {
                  id: "2",
                  descripcion: "Femenino",
                },
              ]}
              getOptionLabel={(option) => option.descripcion}
              id="controlled-demo"
              value={
                [
                  { id: "1", descripcion: "Masculino" },
                  { id: "2", descripcion: "Femenino" },
                ].find((opt) => opt.id == cmbsexo) || null
              }
              onChange={(event, newValue) => {
                setcmbsexo(newValue ? newValue.id : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Seleccione"}
                  variant="outlined"
                  autoComplete="new-password"
                  error={isvalid_cmbsexo}
                  helperText={isvalid_cmbsexo ? "Campo obligatorio *" : ""}
                  disabled={desactivar}
                  onFocus={() => {
                    isvalid_setcmbsexo(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                  }}
                  onBlur={() => {
                    if (cmbsexo === null || cmbsexo === undefined) isvalid_setcmbsexo(true);
                  }}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
              disabled={disabled_txt || desactivar}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Nombre de la madre
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textapaternomadre}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }

                    settextapaternomadre(valor);
                  }}
                  error={isvalid_textapaternomadre}
                  helperText={isvalid_textapaternomadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextapaternomadre(false);

                    isvalid_settextapaternopadre(false);
                    isvalid_settextamaternopadre(false);
                    isvalid_settxtnombrepadre(false);
                    isvalid_settextocupacionpadre(false);

                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    )
                      isvalid_settextapaternomadre(true);
                  }}
                  label={"A. Paterno"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textamaternomadre}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }
                    settextamaternomadre(valor);
                  }}
                  error={isvalid_textamaternomadre}
                  helperText={isvalid_textamaternomadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextamaternomadre(false);
                    isvalid_settextapaternopadre(false);
                    isvalid_settextamaternopadre(false);
                    isvalid_settxtnombrepadre(false);
                    isvalid_settextocupacionpadre(false);

                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !textamaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    )
                      isvalid_settextamaternomadre(true);
                  }}
                  label={"A. Materno"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textnombremadre}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convierte la primera letra de CADA palabra a mayúscula
                    valor = valor.toLowerCase().replace(/(^\w|\s\w)/g, (letra) => {
                      return letra.toUpperCase();
                    });
                    settextnombremadre(valor);
                  }}
                  error={isvalid_textnombremadre}
                  helperText={isvalid_textnombremadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextnombremadre(false);
                    isvalid_settextapaternopadre(false);
                    isvalid_settextamaternopadre(false);
                    isvalid_settxtnombrepadre(false);
                    isvalid_settextocupacionpadre(false);

                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                    if (!textamaternomadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextamaternomadre(true);
                      } else {
                        if (textapaternomadre) {
                          isvalid_settextamaternomadre(true);
                        }
                      }
                    }
                  }}
                  onBlur={() => {
                    if (
                      !textnombremadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    )
                      isvalid_settextnombremadre(true);
                  }}
                  label={"Nombre"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Ocupación de la madre
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              value={textocupacionmadre}
              onChange={(event) => {
                settextocupacionmadre(event.target.value);
              }}
              error={isvalid_textocupacionmadre}
              helperText={isvalid_textocupacionmadre ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settextocupacionmadre(false);
                isvalid_settextapaternopadre(false);
                isvalid_settextamaternopadre(false);
                isvalid_settxtnombrepadre(false);
                isvalid_settextocupacionpadre(false);

                if (!textapellidoP) {
                  isvalid_settextapellidoP(true);
                }
                if (!textapellidoM) {
                  isvalid_settextapellidoM(true);
                }
                if (!textnombre) {
                  isvalid_settextnombre(true);
                }
                if (!txtfechaNacimiento) {
                  isvalid_settxtfechaNacimiento(true);
                }
                if (!textnacionalidad) {
                  isvalid_settextnacionalidad(true);
                }
                if (!txtlugarnacimiento) {
                  isvalid_settxtlugarnacimiento(true);
                }
                if (!cmbsexo) {
                  isvalid_setcmbsexo(true);
                }
                if (
                  !textapaternomadre &&
                  !textapaternopadre &&
                  !textamaternopadre &&
                  !txtnombrepadre &&
                  !textocupacionpadre
                ) {
                  isvalid_settextapaternomadre(true);
                }
                if (!textamaternomadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextamaternomadre(true);
                  } else {
                    if (textapaternomadre) {
                      isvalid_settextamaternomadre(true);
                    }
                  }
                }

                if (!textnombremadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextnombremadre(true);
                  } else {
                    if (textapaternomadre || textamaternomadre) {
                      isvalid_settextnombremadre(true);
                    }
                  }
                }
              }}
              onBlur={() => {
                if (
                  !textocupacionmadre &&
                  !textapaternopadre &&
                  !textamaternopadre &&
                  !txtnombrepadre &&
                  !textocupacionpadre
                )
                  isvalid_settextocupacionmadre(true);
              }}
              label={""}
              variant="outlined"
              style={{ width: "100%", marginBottom: "1.5rem" }}
              size="small"
              disabled={disabled_txt || desactivar}
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Nombre del padre
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textapaternopadre}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }
                    settextapaternopadre(valor);
                  }}
                  error={isvalid_textapaternopadre}
                  helperText={isvalid_textapaternopadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextapaternopadre(false);
                    isvalid_settextapaternomadre(false);
                    isvalid_settextamaternomadre(false);
                    isvalid_settextnombremadre(false);
                    isvalid_settextocupacionmadre(false);

                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    )
                      isvalid_settextapaternopadre(true);
                  }}
                  label={"A. Paterno"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textamaternopadre}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }
                    settextamaternopadre(valor);
                  }}
                  error={isvalid_textamaternopadre}
                  helperText={isvalid_textamaternopadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextamaternopadre(false);
                    isvalid_settextapaternomadre(false);
                    isvalid_settextamaternomadre(false);
                    isvalid_settextnombremadre(false);
                    isvalid_settextocupacionmadre(false);

                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !textamaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    )
                      isvalid_settextamaternopadre(true);
                  }}
                  label={"A. Materno"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={txtnombrepadre}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convierte la primera letra de CADA palabra a mayúscula
                    valor = valor.toLowerCase().replace(/(^\w|\s\w)/g, (letra) => {
                      return letra.toUpperCase();
                    });
                    settxtnombrepadre(valor);
                  }}
                  error={isvalid_txtnombrepadre}
                  helperText={isvalid_txtnombrepadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settxtnombrepadre(false);
                    isvalid_settextapaternomadre(false);
                    isvalid_settextamaternomadre(false);
                    isvalid_settextnombremadre(false);
                    isvalid_settextocupacionmadre(false);

                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }
                    if (!textamaternopadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextamaternopadre(true);
                      } else {
                        if (textapaternopadre) {
                          isvalid_settextamaternopadre(true);
                        }
                      }
                    }
                  }}
                  onBlur={() => {
                    if (
                      !txtnombrepadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    )
                      isvalid_settxtnombrepadre(true);
                  }}
                  label={"Nombre"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Ocupación del padre
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              value={textocupacionpadre}
              onChange={(event) => {
                settextocupacionpadre(event.target.value);
              }}
              error={isvalid_textocupacionpadre}
              helperText={isvalid_textocupacionpadre ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settextocupacionpadre(false);
                isvalid_settextapaternomadre(false);
                isvalid_settextamaternomadre(false);
                isvalid_settextnombremadre(false);
                isvalid_settextocupacionmadre(false);

                if (!textapellidoP) {
                  isvalid_settextapellidoP(true);
                }
                if (!textapellidoM) {
                  isvalid_settextapellidoM(true);
                }
                if (!textnombre) {
                  isvalid_settextnombre(true);
                }
                if (!txtfechaNacimiento) {
                  isvalid_settxtfechaNacimiento(true);
                }
                if (!textnacionalidad) {
                  isvalid_settextnacionalidad(true);
                }
                if (!txtlugarnacimiento) {
                  isvalid_settxtlugarnacimiento(true);
                }
                if (!cmbsexo) {
                  isvalid_setcmbsexo(true);
                }
                if (
                  !textapaternopadre &&
                  !textapaternomadre &&
                  !textamaternomadre &&
                  !textnombremadre &&
                  !textocupacionmadre
                ) {
                  isvalid_settextapaternopadre(true);
                }

                if (!textamaternopadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settextamaternopadre(true);
                  } else {
                    if (textapaternopadre) {
                      isvalid_settextamaternopadre(true);
                    }
                  }
                }
                if (!txtnombrepadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settxtnombrepadre(true);
                  } else {
                    if (textapaternopadre || textamaternopadre) {
                      isvalid_settxtnombrepadre(true);
                    }
                  }
                }
              }}
              onBlur={() => {
                if (
                  !textocupacionpadre &&
                  !textapaternomadre &&
                  !textamaternomadre &&
                  !textnombremadre &&
                  !textocupacionmadre
                )
                  isvalid_settextocupacionpadre(true);
              }}
              label={""}
              variant="outlined"
              style={{ width: "100%", marginBottom: "1.5rem" }}
              size="small"
              disabled={disabled_txt || desactivar}
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Dirección del niño(a)
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              value={textdireccionnino}
              onChange={(event) => {
                settextdireccionnino(event.target.value);
              }}
              error={isvalid_textdireccionnino}
              helperText={isvalid_textdireccionnino ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settextdireccionnino(false);
                if (!textapellidoP) {
                  isvalid_settextapellidoP(true);
                }
                if (!textapellidoM) {
                  isvalid_settextapellidoM(true);
                }
                if (!textnombre) {
                  isvalid_settextnombre(true);
                }
                if (!txtfechaNacimiento) {
                  isvalid_settxtfechaNacimiento(true);
                }
                if (!textnacionalidad) {
                  isvalid_settextnacionalidad(true);
                }
                if (!txtlugarnacimiento) {
                  isvalid_settxtlugarnacimiento(true);
                }
                if (!cmbsexo) {
                  isvalid_setcmbsexo(true);
                }

                if (
                  !textapaternomadre &&
                  !textapaternopadre &&
                  !textamaternopadre &&
                  !txtnombrepadre &&
                  !textocupacionpadre
                ) {
                  isvalid_settextapaternomadre(true);
                }
                if (!textamaternomadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextamaternomadre(true);
                  } else {
                    if (textapaternomadre) {
                      isvalid_settextamaternomadre(true);
                    }
                  }
                }

                if (!textnombremadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextnombremadre(true);
                  } else {
                    if (textapaternomadre || textamaternomadre) {
                      isvalid_settextnombremadre(true);
                    }
                  }
                }
                if (!textocupacionmadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextocupacionmadre(true);
                  } else {
                    if (textapaternomadre || textamaternomadre || textnombremadre) {
                      isvalid_settextocupacionmadre(true);
                    }
                  }
                }

                if (
                  !textapaternopadre &&
                  !textapaternomadre &&
                  !textamaternomadre &&
                  !textnombremadre &&
                  !textocupacionmadre
                ) {
                  isvalid_settextapaternopadre(true);
                }

                if (!textamaternopadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settextamaternopadre(true);
                  } else {
                    if (textapaternopadre) {
                      isvalid_settextamaternopadre(true);
                    }
                  }
                }
                if (!txtnombrepadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settxtnombrepadre(true);
                  } else {
                    if (textapaternopadre || textamaternopadre) {
                      isvalid_settxtnombrepadre(true);
                    }
                  }
                }
                if (!textocupacionpadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settextocupacionpadre(true);
                  } else {
                    if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                      isvalid_settextocupacionpadre(true);
                    }
                  }
                }
              }}
              onBlur={() => {
                if (!textdireccionnino) isvalid_settextdireccionnino(true);
              }}
              label={""}
              variant="outlined"
              style={{ width: "100%", marginBottom: "1.5rem" }}
              size="small"
              multiline
              rows={3}
              disabled={disabled_txt || desactivar}
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Entidad federativa
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={catalogos.entidades}
                  getOptionLabel={(option) => option.entidad}
                  id="controlled-demo"
                  value={find(catalogos.entidades, (opt) => opt.idEntidad === cmbentidad) || null}
                  onChange={(event, newValue) => {
                    if (!newValue) {
                      setcmbentidad(null);
                      setcmbmuicipios([]);
                    } else {
                      setcmbentidad(newValue.idEntidad);
                      var municipios = filter(catalogos.municipios, (item) => {
                        return item.idEntidad == newValue.idEntidad;
                      });
                      if (municipios) {
                        setcmbmuicipios(municipios);
                      }
                    }
                    setcmbmunicipioselect(null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Seleccione"}
                      variant="outlined"
                      autoComplete="new-password"
                      error={isvalid_cmbentidad}
                      helperText={isvalid_cmbentidad ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setcmbentidad(false);
                        if (!textapellidoP) {
                          isvalid_settextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          isvalid_settextapellidoM(true);
                        }
                        if (!textnombre) {
                          isvalid_settextnombre(true);
                        }
                        if (!txtfechaNacimiento) {
                          isvalid_settxtfechaNacimiento(true);
                        }
                        if (!textnacionalidad) {
                          isvalid_settextnacionalidad(true);
                        }
                        if (!txtlugarnacimiento) {
                          isvalid_settxtlugarnacimiento(true);
                        }
                        if (!cmbsexo) {
                          isvalid_setcmbsexo(true);
                        }
                        if (
                          !textapaternomadre &&
                          !textapaternopadre &&
                          !textamaternopadre &&
                          !txtnombrepadre &&
                          !textocupacionpadre
                        ) {
                          isvalid_settextapaternomadre(true);
                        }
                        if (!textamaternomadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextamaternomadre(true);
                          } else {
                            if (textapaternomadre) {
                              isvalid_settextamaternomadre(true);
                            }
                          }
                        }

                        if (!textnombremadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextnombremadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre) {
                              isvalid_settextnombremadre(true);
                            }
                          }
                        }
                        if (!textocupacionmadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextocupacionmadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre || textnombremadre) {
                              isvalid_settextocupacionmadre(true);
                            }
                          }
                        }

                        if (
                          !textapaternopadre &&
                          !textapaternomadre &&
                          !textamaternomadre &&
                          !textnombremadre &&
                          !textocupacionmadre
                        ) {
                          isvalid_settextapaternopadre(true);
                        }

                        if (!textamaternopadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextamaternopadre(true);
                          } else {
                            if (textapaternopadre) {
                              isvalid_settextamaternopadre(true);
                            }
                          }
                        }
                        if (!txtnombrepadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settxtnombrepadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre) {
                              isvalid_settxtnombrepadre(true);
                            }
                          }
                        }
                        if (!textocupacionpadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextocupacionpadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                              isvalid_settextocupacionpadre(true);
                            }
                          }
                        }
                        if (!textdireccionnino) {
                          isvalid_settextdireccionnino(true);
                        }
                      }}
                      onBlur={() => {
                        if (!cmbentidad) isvalid_setcmbentidad(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                />
              </Grid>
              <Grid item xs={12} md={1} lg={1}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Municipio
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={5} lg={5}>
                <Autocomplete
                  options={cmbmuicipios}
                  getOptionLabel={(option) => option.municipio}
                  id="controlled-demo"
                  value={find(cmbmuicipios, (opt) => opt.idMunicipio == cmbmunicipioselect) || null}
                  onChange={(event, newValue) => {
                    if (!newValue) setcmbmunicipioselect(null);
                    else setcmbmunicipioselect(newValue.idMunicipio);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Seleccione"}
                      variant="outlined"
                      autoComplete="new-password"
                      error={isvalid_cmbmunicipioselect}
                      helperText={isvalid_cmbmunicipioselect ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setcmbmunicipioselect(false);
                        if (!textapellidoP) {
                          isvalid_settextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          isvalid_settextapellidoM(true);
                        }
                        if (!textnombre) {
                          isvalid_settextnombre(true);
                        }
                        if (!txtfechaNacimiento) {
                          isvalid_settxtfechaNacimiento(true);
                        }
                        if (!textnacionalidad) {
                          isvalid_settextnacionalidad(true);
                        }
                        if (!txtlugarnacimiento) {
                          isvalid_settxtlugarnacimiento(true);
                        }
                        if (!cmbsexo) {
                          isvalid_setcmbsexo(true);
                        }
                        if (
                          !textapaternomadre &&
                          !textapaternopadre &&
                          !textamaternopadre &&
                          !txtnombrepadre &&
                          !textocupacionpadre
                        ) {
                          isvalid_settextapaternomadre(true);
                        }
                        if (!textamaternomadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextamaternomadre(true);
                          } else {
                            if (textapaternomadre) {
                              isvalid_settextamaternomadre(true);
                            }
                          }
                        }

                        if (!textnombremadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextnombremadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre) {
                              isvalid_settextnombremadre(true);
                            }
                          }
                        }
                        if (!textocupacionmadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextocupacionmadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre || textnombremadre) {
                              isvalid_settextocupacionmadre(true);
                            }
                          }
                        }

                        if (
                          !textapaternopadre &&
                          !textapaternomadre &&
                          !textamaternomadre &&
                          !textnombremadre &&
                          !textocupacionmadre
                        ) {
                          isvalid_settextapaternopadre(true);
                        }

                        if (!textamaternopadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextamaternopadre(true);
                          } else {
                            if (textapaternopadre) {
                              isvalid_settextamaternopadre(true);
                            }
                          }
                        }
                        if (!txtnombrepadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settxtnombrepadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre) {
                              isvalid_settxtnombrepadre(true);
                            }
                          }
                        }
                        if (!textocupacionpadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextocupacionpadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                              isvalid_settextocupacionpadre(true);
                            }
                          }
                        }
                        if (!textdireccionnino) {
                          isvalid_settextdireccionnino(true);
                        }
                        if (!cmbentidad) {
                          isvalid_setcmbentidad(true);
                        }
                      }}
                      onBlur={() => {
                        if (!cmbmunicipioselect) isvalid_setcmbmunicipioselect(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Pediatra / Médico 1er Contacto
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  value={textmedicopediatra1ercontacto}
                  onChange={(event) => {
                    settextmedicopediatra1ercontacto(event.target.value);
                  }}
                  error={isvalid_textmedicopediatra1ercontacto}
                  helperText={isvalid_textmedicopediatra1ercontacto ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextmedicopediatra1ercontacto(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                    if (!textamaternomadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextamaternomadre(true);
                      } else {
                        if (textapaternomadre) {
                          isvalid_settextamaternomadre(true);
                        }
                      }
                    }

                    if (!textnombremadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextnombremadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre) {
                          isvalid_settextnombremadre(true);
                        }
                      }
                    }
                    if (!textocupacionmadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextocupacionmadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre || textnombremadre) {
                          isvalid_settextocupacionmadre(true);
                        }
                      }
                    }

                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }

                    if (!textamaternopadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextamaternopadre(true);
                      } else {
                        if (textapaternopadre) {
                          isvalid_settextamaternopadre(true);
                        }
                      }
                    }
                    if (!txtnombrepadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settxtnombrepadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre) {
                          isvalid_settxtnombrepadre(true);
                        }
                      }
                    }
                    if (!textocupacionpadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextocupacionpadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                          isvalid_settextocupacionpadre(true);
                        }
                      }
                    }
                    if (!textdireccionnino) {
                      isvalid_settextdireccionnino(true);
                    }
                    if (!cmbentidad) {
                      isvalid_setcmbentidad(true);
                    }
                    if (!cmbmunicipioselect) {
                      isvalid_setcmbmunicipioselect(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textmedicopediatra1ercontacto)
                      isvalid_settextmedicopediatra1ercontacto(true);
                  }}
                  label={""}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={12} md={1} lg={1}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Celular
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={5} lg={5}>
                <TextField
                  value={textcelularmedico1ercontacto}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (/^\d*$/.test(value)) {
                      settextcelularmedico1ercontacto(value);
                    }
                  }}
                  error={isvalid_textcelularmedico1ercontacto}
                  helperText={isvalid_textcelularmedico1ercontacto ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextcelularmedico1ercontacto(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                    if (!textamaternomadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextamaternomadre(true);
                      } else {
                        if (textapaternomadre) {
                          isvalid_settextamaternomadre(true);
                        }
                      }
                    }

                    if (!textnombremadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextnombremadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre) {
                          isvalid_settextnombremadre(true);
                        }
                      }
                    }
                    if (!textocupacionmadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextocupacionmadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre || textnombremadre) {
                          isvalid_settextocupacionmadre(true);
                        }
                      }
                    }

                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }

                    if (!textamaternopadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextamaternopadre(true);
                      } else {
                        if (textapaternopadre) {
                          isvalid_settextamaternopadre(true);
                        }
                      }
                    }
                    if (!txtnombrepadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settxtnombrepadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre) {
                          isvalid_settxtnombrepadre(true);
                        }
                      }
                    }
                    if (!textocupacionpadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextocupacionpadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                          isvalid_settextocupacionpadre(true);
                        }
                      }
                    }
                    if (!textdireccionnino) {
                      isvalid_settextdireccionnino(true);
                    }
                    if (!cmbentidad) {
                      isvalid_setcmbentidad(true);
                    }
                    if (!cmbmunicipioselect) {
                      isvalid_setcmbmunicipioselect(true);
                    }
                    if (!textmedicopediatra1ercontacto) {
                      isvalid_settextmedicopediatra1ercontacto(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textcelularmedico1ercontacto) {
                      isvalid_settextcelularmedico1ercontacto(true);
                    } else if (
                      !validator.isLength(textcelularmedico1ercontacto, { min: 10, max: 10 })
                    ) {
                      toast.error("Numero de contacto incorrecto, debe ser a 10 digitos");
                      isvalid_settextcelularmedico1ercontacto(true);
                    }
                  }}
                  label={""}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                    maxLength: 10, // Límite de 10 caracteres
                  }}
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Dirección del pediatra
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              value={textdirpediatra}
              onChange={(event) => {
                settextdirpediatra(event.target.value);
              }}
              error={isvalid_textdirpediatra}
              helperText={isvalid_textdirpediatra ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settextdirpediatra(false);
                if (!textapellidoP) {
                  isvalid_settextapellidoP(true);
                }
                if (!textapellidoM) {
                  isvalid_settextapellidoM(true);
                }
                if (!textnombre) {
                  isvalid_settextnombre(true);
                }
                if (!txtfechaNacimiento) {
                  isvalid_settxtfechaNacimiento(true);
                }
                if (!textnacionalidad) {
                  isvalid_settextnacionalidad(true);
                }
                if (!txtlugarnacimiento) {
                  isvalid_settxtlugarnacimiento(true);
                }
                if (!cmbsexo) {
                  isvalid_setcmbsexo(true);
                }
                if (
                  !textapaternomadre &&
                  !textapaternopadre &&
                  !textamaternopadre &&
                  !txtnombrepadre &&
                  !textocupacionpadre
                ) {
                  isvalid_settextapaternomadre(true);
                }
                if (!textamaternomadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextamaternomadre(true);
                  } else {
                    if (textapaternomadre) {
                      isvalid_settextamaternomadre(true);
                    }
                  }
                }

                if (!textnombremadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextnombremadre(true);
                  } else {
                    if (textapaternomadre || textamaternomadre) {
                      isvalid_settextnombremadre(true);
                    }
                  }
                }
                if (!textocupacionmadre) {
                  if (
                    !textapaternopadre &&
                    !textamaternopadre &&
                    !txtnombrepadre &&
                    !textocupacionpadre
                  ) {
                    isvalid_settextocupacionmadre(true);
                  } else {
                    if (textapaternomadre || textamaternomadre || textnombremadre) {
                      isvalid_settextocupacionmadre(true);
                    }
                  }
                }

                if (
                  !textapaternopadre &&
                  !textapaternomadre &&
                  !textamaternomadre &&
                  !textnombremadre &&
                  !textocupacionmadre
                ) {
                  isvalid_settextapaternopadre(true);
                }

                if (!textamaternopadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settextamaternopadre(true);
                  } else {
                    if (textapaternopadre) {
                      isvalid_settextamaternopadre(true);
                    }
                  }
                }
                if (!txtnombrepadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settxtnombrepadre(true);
                  } else {
                    if (textapaternopadre || textamaternopadre) {
                      isvalid_settxtnombrepadre(true);
                    }
                  }
                }
                if (!textocupacionpadre) {
                  if (
                    !textapaternomadre &&
                    !textamaternomadre &&
                    !textnombremadre &&
                    !textocupacionmadre
                  ) {
                    isvalid_settextocupacionpadre(true);
                  } else {
                    if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                      isvalid_settextocupacionpadre(true);
                    }
                  }
                }
                if (!textdireccionnino) {
                  isvalid_settextdireccionnino(true);
                }
                if (!cmbentidad) {
                  isvalid_setcmbentidad(true);
                }
                if (!cmbmunicipioselect) {
                  isvalid_setcmbmunicipioselect(true);
                }
                if (!textmedicopediatra1ercontacto) {
                  isvalid_settextmedicopediatra1ercontacto(true);
                }
                if (!textcelularmedico1ercontacto) {
                  isvalid_settextcelularmedico1ercontacto(true);
                }
              }}
              onBlur={() => {
                if (!textdirpediatra) isvalid_settextdirpediatra(true);
              }}
              label={""}
              variant="outlined"
              style={{ width: "100%", marginBottom: "1.5rem" }}
              size="small"
              multiline
              rows={3}
              disabled={disabled_txt || desactivar}
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Cuidador primario del niño(a)
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textcuidadorninioP}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }
                    settextcuidadorninioP(valor);
                  }}
                  error={isvalid_textcuidadorninioP}
                  helperText={isvalid_textcuidadorninioP ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextcuidadorninioP(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                    if (!textamaternomadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextamaternomadre(true);
                      } else {
                        if (textapaternomadre) {
                          isvalid_settextamaternomadre(true);
                        }
                      }
                    }

                    if (!textnombremadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextnombremadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre) {
                          isvalid_settextnombremadre(true);
                        }
                      }
                    }
                    if (!textocupacionmadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextocupacionmadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre || textnombremadre) {
                          isvalid_settextocupacionmadre(true);
                        }
                      }
                    }

                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }

                    if (!textamaternopadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextamaternopadre(true);
                      } else {
                        if (textapaternopadre) {
                          isvalid_settextamaternopadre(true);
                        }
                      }
                    }
                    if (!txtnombrepadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settxtnombrepadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre) {
                          isvalid_settxtnombrepadre(true);
                        }
                      }
                    }
                    if (!textocupacionpadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextocupacionpadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                          isvalid_settextocupacionpadre(true);
                        }
                      }
                    }
                    if (!textdireccionnino) {
                      isvalid_settextdireccionnino(true);
                    }
                    if (!cmbentidad) {
                      isvalid_setcmbentidad(true);
                    }
                    if (!cmbmunicipioselect) {
                      isvalid_setcmbmunicipioselect(true);
                    }
                    if (!textmedicopediatra1ercontacto) {
                      isvalid_settextmedicopediatra1ercontacto(true);
                    }
                    if (!textcelularmedico1ercontacto) {
                      isvalid_settextcelularmedico1ercontacto(true);
                    }
                    if (!textdirpediatra) {
                      isvalid_settextdirpediatra(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textcuidadorninioP) isvalid_settextcuidadorninioP(true);
                  }}
                  label={"A. Paterno"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textcuidadorninioM}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir solo la primera letra a mayúscula
                    if (valor.length > 0) {
                      valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                    }
                    settextcuidadorninioM(valor);
                  }}
                  error={isvalid_textcuidadorninioM}
                  helperText={isvalid_textcuidadorninioM ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextcuidadorninioM(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                    if (!textamaternomadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextamaternomadre(true);
                      } else {
                        if (textapaternomadre) {
                          isvalid_settextamaternomadre(true);
                        }
                      }
                    }

                    if (!textnombremadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextnombremadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre) {
                          isvalid_settextnombremadre(true);
                        }
                      }
                    }
                    if (!textocupacionmadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextocupacionmadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre || textnombremadre) {
                          isvalid_settextocupacionmadre(true);
                        }
                      }
                    }

                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }

                    if (!textamaternopadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextamaternopadre(true);
                      } else {
                        if (textapaternopadre) {
                          isvalid_settextamaternopadre(true);
                        }
                      }
                    }
                    if (!txtnombrepadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settxtnombrepadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre) {
                          isvalid_settxtnombrepadre(true);
                        }
                      }
                    }
                    if (!textocupacionpadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextocupacionpadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                          isvalid_settextocupacionpadre(true);
                        }
                      }
                    }
                    if (!textdireccionnino) {
                      isvalid_settextdireccionnino(true);
                    }
                    if (!cmbentidad) {
                      isvalid_setcmbentidad(true);
                    }
                    if (!cmbmunicipioselect) {
                      isvalid_setcmbmunicipioselect(true);
                    }
                    if (!textmedicopediatra1ercontacto) {
                      isvalid_settextmedicopediatra1ercontacto(true);
                    }
                    if (!textcelularmedico1ercontacto) {
                      isvalid_settextcelularmedico1ercontacto(true);
                    }
                    if (!textdirpediatra) {
                      isvalid_settextdirpediatra(true);
                    }
                    if (!textcuidadorninioP) {
                      isvalid_settextcuidadorninioP(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textcuidadorninioM) isvalid_settextcuidadorninioM(true);
                  }}
                  label={"A. Materno"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  value={textcuidadorninioN}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convierte la primera letra de CADA palabra a mayúscula
                    valor = valor.toLowerCase().replace(/(^\w|\s\w)/g, (letra) => {
                      return letra.toUpperCase();
                    });
                    settextcuidadorninioN(valor);
                  }}
                  error={isvalid_textcuidadorninioN}
                  helperText={isvalid_textcuidadorninioN ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settextcuidadorninioN(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                    if (!textamaternomadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextamaternomadre(true);
                      } else {
                        if (textapaternomadre) {
                          isvalid_settextamaternomadre(true);
                        }
                      }
                    }

                    if (!textnombremadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextnombremadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre) {
                          isvalid_settextnombremadre(true);
                        }
                      }
                    }
                    if (!textocupacionmadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextocupacionmadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre || textnombremadre) {
                          isvalid_settextocupacionmadre(true);
                        }
                      }
                    }

                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }

                    if (!textamaternopadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextamaternopadre(true);
                      } else {
                        if (textapaternopadre) {
                          isvalid_settextamaternopadre(true);
                        }
                      }
                    }
                    if (!txtnombrepadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settxtnombrepadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre) {
                          isvalid_settxtnombrepadre(true);
                        }
                      }
                    }
                    if (!textocupacionpadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextocupacionpadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                          isvalid_settextocupacionpadre(true);
                        }
                      }
                    }
                    if (!textdireccionnino) {
                      isvalid_settextdireccionnino(true);
                    }
                    if (!cmbentidad) {
                      isvalid_setcmbentidad(true);
                    }
                    if (!cmbmunicipioselect) {
                      isvalid_setcmbmunicipioselect(true);
                    }
                    if (!textmedicopediatra1ercontacto) {
                      isvalid_settextmedicopediatra1ercontacto(true);
                    }
                    if (!textcelularmedico1ercontacto) {
                      isvalid_settextcelularmedico1ercontacto(true);
                    }
                    if (!textdirpediatra) {
                      isvalid_settextdirpediatra(true);
                    }
                    if (!textcuidadorninioP) {
                      isvalid_settextcuidadorninioP(true);
                    }
                    if (!textcuidadorninioM) {
                      isvalid_settextcuidadorninioM(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textcuidadorninioN) isvalid_settextcuidadorninioN(true);
                  }}
                  label={"Nombre"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Parentesco con el niño(a)
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={catalogos.parentescos}
                  getOptionLabel={(option) => option.descripcion}
                  id="controlled-demo"
                  value={
                    find(
                      catalogos.parentescos,
                      (opt) => opt.idParentescoCandidato === cmbparentesco
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setcmbparentesco(newValue ? newValue.idParentescoCandidato : null);
                    if (newValue != null && newValue.descripcion == "Otro") {
                      setidisabled_settextParentescoespec(false);
                      setisValid_settextParentescoespec(true);
                    } else {
                      setidisabled_settextParentescoespec(true);
                      setisValid_settextParentescoespec(false);
                      settextParentescoespec("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Seleccione"}
                      variant="outlined"
                      autoComplete="new-password"
                      error={isvalid_cmbparentesco}
                      helperText={isvalid_cmbparentesco ? "Campo obligatorio *" : ""}
                      disabled={desactivar}
                      onFocus={() => {
                        isvalid_setcmbparentesco(false);
                        if (!textapellidoP) {
                          isvalid_settextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          isvalid_settextapellidoM(true);
                        }
                        if (!textnombre) {
                          isvalid_settextnombre(true);
                        }
                        if (!txtfechaNacimiento) {
                          isvalid_settxtfechaNacimiento(true);
                        }
                        if (!textnacionalidad) {
                          isvalid_settextnacionalidad(true);
                        }
                        if (!txtlugarnacimiento) {
                          isvalid_settxtlugarnacimiento(true);
                        }
                        if (!cmbsexo) {
                          isvalid_setcmbsexo(true);
                        }
                        if (
                          !textapaternomadre &&
                          !textapaternopadre &&
                          !textamaternopadre &&
                          !txtnombrepadre &&
                          !textocupacionpadre
                        ) {
                          isvalid_settextapaternomadre(true);
                        }
                        if (!textamaternomadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextamaternomadre(true);
                          } else {
                            if (textapaternomadre) {
                              isvalid_settextamaternomadre(true);
                            }
                          }
                        }

                        if (!textnombremadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextnombremadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre) {
                              isvalid_settextnombremadre(true);
                            }
                          }
                        }
                        if (!textocupacionmadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextocupacionmadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre || textnombremadre) {
                              isvalid_settextocupacionmadre(true);
                            }
                          }
                        }

                        if (
                          !textapaternopadre &&
                          !textapaternomadre &&
                          !textamaternomadre &&
                          !textnombremadre &&
                          !textocupacionmadre
                        ) {
                          isvalid_settextapaternopadre(true);
                        }

                        if (!textamaternopadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextamaternopadre(true);
                          } else {
                            if (textapaternopadre) {
                              isvalid_settextamaternopadre(true);
                            }
                          }
                        }
                        if (!txtnombrepadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settxtnombrepadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre) {
                              isvalid_settxtnombrepadre(true);
                            }
                          }
                        }
                        if (!textocupacionpadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextocupacionpadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                              isvalid_settextocupacionpadre(true);
                            }
                          }
                        }
                        if (!textdireccionnino) {
                          isvalid_settextdireccionnino(true);
                        }
                        if (!cmbentidad) {
                          isvalid_setcmbentidad(true);
                        }
                        if (!cmbmunicipioselect) {
                          isvalid_setcmbmunicipioselect(true);
                        }
                        if (!textmedicopediatra1ercontacto) {
                          isvalid_settextmedicopediatra1ercontacto(true);
                        }
                        if (!textcelularmedico1ercontacto) {
                          isvalid_settextcelularmedico1ercontacto(true);
                        }
                        if (!textdirpediatra) {
                          isvalid_settextdirpediatra(true);
                        }
                        if (!textcuidadorninioP) {
                          isvalid_settextcuidadorninioP(true);
                        }
                        if (!textcuidadorninioM) {
                          isvalid_settextcuidadorninioM(true);
                        }
                        if (!textcuidadorninioN) {
                          isvalid_settextcuidadorninioN(true);
                        }
                      }}
                      onBlur={() => {
                        if (!cmbparentesco) isvalid_setcmbparentesco(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  value={textParentescoespec}
                  error={isValid_textParentescoespec}
                  disabled={disabled_textParentescoespec || desactivar}
                  helperText={isValid_textParentescoespec ? "Campo obligatorio *" : ""}
                  onChange={(e) => {
                    if (cmbparentesco != null && cmbparentesco == "5") {
                      settextParentescoespec(e.target.value);
                    }
                  }}
                  onFocus={() => {
                    setisValid_settextParentescoespec(false);
                  }}
                  onBlur={() => {
                    if (!textParentescoespec && cmbparentesco != null && cmbparentesco == "5") {
                      setisValid_settextParentescoespec(true);
                    }
                  }}
                  label={"Especifique"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  name="texteeeeee"
                  autoComplete="new_texteeeeee"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Cuenta con servicio médico
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={catalogos.serviciosMedicos}
                  getOptionLabel={(option) => option.descripcion}
                  id="controlled-demo"
                  value={
                    find(
                      catalogos.serviciosMedicos,
                      (opt) => opt.idServicioMedico === cmbsermedico
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setcmbsermedico(newValue ? newValue.idServicioMedico : null);
                    if (newValue != null && newValue.descripcion == "Otro (Especificar)") {
                      setidisabled_settextsermedicoOtro(false);
                      isvalid_settextsermedicoOtro(true);
                    } else {
                      setidisabled_settextsermedicoOtro(true);
                      isvalid_settextsermedicoOtro(false);
                      settextsermedicoOtro("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Seleccione"}
                      variant="outlined"
                      autoComplete="new-password"
                      error={isvalid_cmbsermedico}
                      helperText={isvalid_cmbsermedico ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setcmbsermedico(false);
                        if (!textapellidoP) {
                          isvalid_settextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          isvalid_settextapellidoM(true);
                        }
                        if (!textnombre) {
                          isvalid_settextnombre(true);
                        }
                        if (!txtfechaNacimiento) {
                          isvalid_settxtfechaNacimiento(true);
                        }
                        if (!textnacionalidad) {
                          isvalid_settextnacionalidad(true);
                        }
                        if (!txtlugarnacimiento) {
                          isvalid_settxtlugarnacimiento(true);
                        }
                        if (!cmbsexo) {
                          isvalid_setcmbsexo(true);
                        }
                        if (
                          !textapaternomadre &&
                          !textapaternopadre &&
                          !textamaternopadre &&
                          !txtnombrepadre &&
                          !textocupacionpadre
                        ) {
                          isvalid_settextapaternomadre(true);
                        }
                        if (!textamaternomadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextamaternomadre(true);
                          } else {
                            if (textapaternomadre) {
                              isvalid_settextamaternomadre(true);
                            }
                          }
                        }

                        if (!textnombremadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextnombremadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre) {
                              isvalid_settextnombremadre(true);
                            }
                          }
                        }
                        if (!textocupacionmadre) {
                          if (
                            !textapaternopadre &&
                            !textamaternopadre &&
                            !txtnombrepadre &&
                            !textocupacionpadre
                          ) {
                            isvalid_settextocupacionmadre(true);
                          } else {
                            if (textapaternomadre || textamaternomadre || textnombremadre) {
                              isvalid_settextocupacionmadre(true);
                            }
                          }
                        }

                        if (
                          !textapaternopadre &&
                          !textapaternomadre &&
                          !textamaternomadre &&
                          !textnombremadre &&
                          !textocupacionmadre
                        ) {
                          isvalid_settextapaternopadre(true);
                        }

                        if (!textamaternopadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextamaternopadre(true);
                          } else {
                            if (textapaternopadre) {
                              isvalid_settextamaternopadre(true);
                            }
                          }
                        }
                        if (!txtnombrepadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settxtnombrepadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre) {
                              isvalid_settxtnombrepadre(true);
                            }
                          }
                        }
                        if (!textocupacionpadre) {
                          if (
                            !textapaternomadre &&
                            !textamaternomadre &&
                            !textnombremadre &&
                            !textocupacionmadre
                          ) {
                            isvalid_settextocupacionpadre(true);
                          } else {
                            if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                              isvalid_settextocupacionpadre(true);
                            }
                          }
                        }
                        if (!textdireccionnino) {
                          isvalid_settextdireccionnino(true);
                        }
                        if (!cmbentidad) {
                          isvalid_setcmbentidad(true);
                        }
                        if (!cmbmunicipioselect) {
                          isvalid_setcmbmunicipioselect(true);
                        }
                        if (!textmedicopediatra1ercontacto) {
                          isvalid_settextmedicopediatra1ercontacto(true);
                        }
                        if (!textcelularmedico1ercontacto) {
                          isvalid_settextcelularmedico1ercontacto(true);
                        }
                        if (!textdirpediatra) {
                          isvalid_settextdirpediatra(true);
                        }
                        if (!textcuidadorninioP) {
                          isvalid_settextcuidadorninioP(true);
                        }
                        if (!textcuidadorninioM) {
                          isvalid_settextcuidadorninioM(true);
                        }
                        if (!textcuidadorninioN) {
                          isvalid_settextcuidadorninioN(true);
                        }
                        if (!cmbparentesco) {
                          isvalid_setcmbparentesco(true);
                        }
                      }}
                      onBlur={() => {
                        if (!cmbsermedico) isvalid_setcmbsermedico(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                />
              </Grid>
              <Grid item xs={12} md={1} lg={1}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Otro
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={5} lg={5}>
                <TextField
                  value={textsermedicoOtro}
                  error={isvalid_textsermedicoOtro}
                  helperText={isvalid_textsermedicoOtro ? "Campo obligatorio *" : ""}
                  onChange={(e) => {
                    if (cmbsermedico != null && cmbsermedico == "8") {
                      settextsermedicoOtro(e.target.value);
                    }
                  }}
                  onFocus={() => {
                    isvalid_settextsermedicoOtro(false);
                    if (!textapellidoP) {
                      isvalid_settextapellidoP(true);
                    }
                    if (!textapellidoM) {
                      isvalid_settextapellidoM(true);
                    }
                    if (!textnombre) {
                      isvalid_settextnombre(true);
                    }
                    if (!txtfechaNacimiento) {
                      isvalid_settxtfechaNacimiento(true);
                    }
                    if (!textnacionalidad) {
                      isvalid_settextnacionalidad(true);
                    }
                    if (!txtlugarnacimiento) {
                      isvalid_settxtlugarnacimiento(true);
                    }
                    if (!cmbsexo) {
                      isvalid_setcmbsexo(true);
                    }
                    if (
                      !textapaternomadre &&
                      !textapaternopadre &&
                      !textamaternopadre &&
                      !txtnombrepadre &&
                      !textocupacionpadre
                    ) {
                      isvalid_settextapaternomadre(true);
                    }
                    if (!textamaternomadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextamaternomadre(true);
                      } else {
                        if (textapaternomadre) {
                          isvalid_settextamaternomadre(true);
                        }
                      }
                    }

                    if (!textnombremadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextnombremadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre) {
                          isvalid_settextnombremadre(true);
                        }
                      }
                    }
                    if (!textocupacionmadre) {
                      if (
                        !textapaternopadre &&
                        !textamaternopadre &&
                        !txtnombrepadre &&
                        !textocupacionpadre
                      ) {
                        isvalid_settextocupacionmadre(true);
                      } else {
                        if (textapaternomadre || textamaternomadre || textnombremadre) {
                          isvalid_settextocupacionmadre(true);
                        }
                      }
                    }

                    if (
                      !textapaternopadre &&
                      !textapaternomadre &&
                      !textamaternomadre &&
                      !textnombremadre &&
                      !textocupacionmadre
                    ) {
                      isvalid_settextapaternopadre(true);
                    }

                    if (!textamaternopadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextamaternopadre(true);
                      } else {
                        if (textapaternopadre) {
                          isvalid_settextamaternopadre(true);
                        }
                      }
                    }
                    if (!txtnombrepadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settxtnombrepadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre) {
                          isvalid_settxtnombrepadre(true);
                        }
                      }
                    }
                    if (!textocupacionpadre) {
                      if (
                        !textapaternomadre &&
                        !textamaternomadre &&
                        !textnombremadre &&
                        !textocupacionmadre
                      ) {
                        isvalid_settextocupacionpadre(true);
                      } else {
                        if (textapaternopadre || textamaternopadre || txtnombrepadre) {
                          isvalid_settextocupacionpadre(true);
                        }
                      }
                    }
                    if (!textdireccionnino) {
                      isvalid_settextdireccionnino(true);
                    }
                    if (!cmbentidad) {
                      isvalid_setcmbentidad(true);
                    }
                    if (!cmbmunicipioselect) {
                      isvalid_setcmbmunicipioselect(true);
                    }
                    if (!textmedicopediatra1ercontacto) {
                      isvalid_settextmedicopediatra1ercontacto(true);
                    }
                    if (!textcelularmedico1ercontacto) {
                      isvalid_settextcelularmedico1ercontacto(true);
                    }
                    if (!textdirpediatra) {
                      isvalid_settextdirpediatra(true);
                    }
                    if (!textcuidadorninioP) {
                      isvalid_settextcuidadorninioP(true);
                    }
                    if (!textcuidadorninioM) {
                      isvalid_settextcuidadorninioM(true);
                    }
                    if (!textcuidadorninioN) {
                      isvalid_settextcuidadorninioN(true);
                    }
                    if (!cmbparentesco) {
                      isvalid_setcmbparentesco(true);
                    }
                    if (!cmbsermedico) {
                      isvalid_setcmbsermedico(true);
                    }
                  }}
                  onBlur={() => {
                    if (!textsermedicoOtro && cmbsermedico != null && cmbsermedico == "8") {
                      isvalid_settextsermedicoOtro(true);
                    }
                  }}
                  label={""}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  size="small"
                  disabled={disabled_txt || desactivar}
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {vista === "visualizar" ? null : (
          <>
            <MDBox textAlign="center">
              <MDTypography variant="h6" color="info" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                *Información para fines estadísticos, no se requiere que renuncies a ningún tipo de
                servicio médico público o privado.
              </MDTypography>
            </MDBox>
            <MDBox textAlign="right">
              <Button
                variant="contained"
                onClick={() => ValidaForm()}
                sx={{ mt: 1, mr: 1 }}
                size="small"
                color="primary"
              >
                {"Continuar"}
              </Button>
              <Button
                variant="contained"
                disabled={false}
                onClick={() => handleBack()}
                sx={{ mt: 1, mr: 1 }}
                color="secondary"
                size="small"
              >
                Volver
              </Button>
            </MDBox>
          </>
        )}
      </>
    );
  }
);

export default InformacionGeneralMenor;
